import PageView from '@/layouts/PageView';

/**
 * 动态路由列表
 * 1、载入前会用根据用户权限列表，移除该用户不具备的权限
 * 2、该列表会生成主菜单，meta: {invisible:true}则表示不显示在主菜单，目前最多生成2级菜单
 */

export const routerList = [
	{
		path: '/member',
		name: '用户管理',
		meta: {
			icon: 'team',
			title: 'menu.member'
		},
		component: PageView,
		children: [{
			path: '/member/userList',
			name: '用户列表',
			meta: { title: 'menu.member.user-list' },
			component: () => import('@/pages/member/user/UserList')
		}, {
			path: '/member/userAccountList',
			name: '账户流水',
			meta: { title: 'menu.member.user-account-list' },
			component: () => import('@/pages/member/user/UserAccountList')
		}, {
			path: '/member/userRechargeList',
			name: '上分记录',
			meta: { title: 'menu.member.user-recharge-list' },
			component: () => import('@/pages/member/user/UserRechargeList')
		}, {
			path: '/member/userCashoutList',
			name: '下分记录',
			meta: { title: 'menu.member.user-cashout-list' },
			component: () => import('@/pages/member/user/UserCashoutList')
		}]
	},
	{
		path: '/op',
		name: '运营支撑',
		meta: {
			icon: 'profile',
			title: 'menu.op'
		},
		component: PageView,
		children: [{
			path: '/op/betList',
			name: '下注记录',
			meta: { title: 'menu.op.bet-list' },
			component: () => import('@/pages/op/bet/BetList')
		}, {
			path: '/op/lottoList',
			name: '开奖数据',
			meta: { title: 'menu.op.lotto-list' },
			component: () => import('@/pages/op/lotto/LottoList')
		}, {
			path: '/op/dddsSetting',
			name: '赔率设置',
			meta: { title: 'menu.op.lotto-bet-setting' },
			component: () => import('@/pages/op/OddsSetting')
		}]
	},
	{
		path: '/finance',
		name: '统计报表',
		meta: {
			icon: 'profile',
			title: '统计报表'
		},
		component: PageView,
		children: [{
			path: '/finance/platformStatList',
			name: '平台统计',
			component: () => import('@/pages/finance/PlatformStatList')
		}, {
			path: '/finance/userStatList',
			name: '用户统计',
			component: () => import('@/pages/finance/UserStatList')
		}, {
			path: '/finance/lottoIssueStatList',
			name: '开奖统计',
			component: () => import('@/pages/finance/LottoIssueStatList.vue')
		}]
	},
	{
		path: '/system',
		name: '系统管理',
		meta: {
			icon: 'setting',
			title: 'menu.system'
		},
		component: PageView,
		children: [{
				path: '/system/adminList',
				name: '管理员列表',
				component: () => import('@/pages/system/admin/AdminList')
			},
			{
				path: '/system/roleList',
				name: '角色列表',
				component: () => import('@/pages/system/role/RoleList')
			},
			{
				path: '/system/funcList',
				name: '资源列表',
				component: () => import('@/pages/system/func/FuncList')
			},
		]
	}
]